// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Share';

// eslint-disable-next-line react/prop-types
export function ShareDrawer({ darkMode = false }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 14 18"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={TITLE}
    >
      <title>{TITLE}</title>
      <path
        d="M6.55916 0.730957L2.39505 3.99223L3.01164 4.77951L6.05916 2.39274V9.99411H7.05916V2.39274L10.1067 4.77951L10.7233 3.99223L6.55916 0.730957Z"
        fill={darkMode ? 'white' : 'black'}
      />
      <path
        d="M0 8.91551V14.808H13.1183V8.91551H12.1183V13.808H1V8.91551H0Z"
        fill={darkMode ? 'white' : 'black'}
      />
    </svg>
  );
}
